module.exports = __webpack_public_path__ + "static/img/IMG_20170525_130748.b354ba83.jpg";